export const UPDATE_THOR_GROUND_UP_DATA = 'UPDATE_THOR_GROUND_UP_DATA';
export const RESET_SRP_STORE = 'RESET_SRP_STORE';
export const SORT_ONWARD_FLIGHTS_GROUND_UP = 'SORT_ONWARD_FLIGHTS_GROUND_UP';
export const SORT_RETURN_FLIGHTS_GROUND_UP = 'SORT_RETURN_FLIGHTS_GROUND_UP';
export const APPLY_ONWARD_FILTERS_FOR_GROUND_UP = 'APPLY_ONWARD_FILTERS_FOR_GROUND_UP';
export const APPLY_RETURN_FILTERS_FOR_GROUND_UP = 'APPLY_RETURN_FILTERS_FOR_GROUND_UP';
export const APPLY_COMMON_FILTERS_FOR_GROUND_UP = 'APPLY_COMMON_FILTERS_FOR_GROUND_UP';
export const SET_ONWARD_SELECTED_FLIGHT = 'SET_ONWARD_SELECTED_FLIGHT';
export const SET_RETURN_SELECTED_FLIGHT = 'SET_RETURN_SELECTED_FLIGHT';
export const SET_CHUNKS_PREFETCHED_ON_SERVER_GROUND_UP =
  'SET_CHUNKS_PREFETCHED_ON_SERVER_GROUND_UP';
export const RECEIVED_ALL_GROUND_UP_CHUNKS = 'RECEIVED_ALL_GROUND_UP_CHUNKS';
export const UPDATE_GROUND_UP_STORE_STATUS = 'UPDATE_GROUND_UP_STORE_STATUS';
export const SET_FARE_TRENDS_FOR_GROUND_UP = 'SET_FARE_TRENDS_FOR_GROUND_UP';
export const UPDATE_ONWARD_SCROLL_LEFT_VALUE = 'UPDATE_ONWARD_SCROLL_LEFT_VALUE';
export const UPDATE_RETURN_SCROLL_LEFT_VALUE = 'UPDATE_RETURN_SCROLL_LEFT_VALUE';
export const UPDATE_QUERY_PARAMS_FOR_GROUND_UP = 'UPDATE_QUERY_PARAMS_FOR_GROUND_UP';
export const UPDATE_SEARCH_STRING_FOR_GROUND_UP = 'UPDATE_SEARCH_STRING_FOR_GROUND_UP';
export const SET_MODIFY_SEARCH_WIDGET = 'SET_MODIFY_SEARCH_WIDGET';
export const SET_SHOW_ONWARD_JOURNEY_TYPE = 'SET_SHOW_ONWARD_JOURNEY_TYPE';
export const SET_PRE_SEARCH_BANNER_DETAILS = 'SET_PRE_SEARCH_BANNER_DETAILS';
export const SET_SELECTED_BANNER_DETAILS = 'SET_SELECTED_BANNER_DETAILS';
export const SET_FARE_TRENDS_PREFETCHED_ON_SERVER = 'SET_FARE_TRENDS_PREFETCHED_ON_SERVER';
export const SET_BANNERS_PREFETCHED_ON_SERVER = 'SET_BANNERS_PREFETCHED_ON_SERVER';
export const SET_BRP_APPLIED_OFFER_PROMO_CODE = 'SET_BRP_APPLIED_OFFER_PROMO_CODE';

export function updateThorData(actionData) {
  return {
    type: UPDATE_THOR_GROUND_UP_DATA,
    actionData
  };
}

export function resetSRPStore() {
  return {
    type: RESET_SRP_STORE
  };
}

export function applyOnwardSort(actionData) {
  return {
    type: SORT_ONWARD_FLIGHTS_GROUND_UP,
    actionData
  };
}

export function applyReturnSort(actionData) {
  return {
    type: SORT_RETURN_FLIGHTS_GROUND_UP,
    actionData
  };
}

export function applyOnwardFilters(actionData) {
  return {
    type: APPLY_ONWARD_FILTERS_FOR_GROUND_UP,
    actionData
  };
}

export function applyReturnFilters(actionData) {
  return {
    type: APPLY_RETURN_FILTERS_FOR_GROUND_UP,
    actionData
  };
}

export function applyCommonFilters(actionData) {
  return {
    type: APPLY_COMMON_FILTERS_FOR_GROUND_UP,
    actionData
  };
}

export function setOnwardSelectedFlight(actionData) {
  return {
    type: SET_ONWARD_SELECTED_FLIGHT,
    actionData
  };
}

export function setReturnSelectedFlight(actionData) {
  return {
    type: SET_RETURN_SELECTED_FLIGHT,
    actionData
  };
}

export function setChunksPrefetchOnServerForGroundUp(actionData) {
  return {
    type: SET_CHUNKS_PREFETCHED_ON_SERVER_GROUND_UP,
    actionData
  };
}

export function receivedAllChunksForGroundUp() {
  return {
    type: RECEIVED_ALL_GROUND_UP_CHUNKS
  };
}

export function updateGroundUpStoreEmptyStatus(actionData) {
  return {
    type: UPDATE_GROUND_UP_STORE_STATUS,
    actionData
  };
}

export function setFareTrendsForGroundUp(actionData) {
  return {
    type: SET_FARE_TRENDS_FOR_GROUND_UP,
    actionData
  };
}

export function setFareTrendsPrefetchOnServer(actionData) {
  return {
    type: SET_FARE_TRENDS_PREFETCHED_ON_SERVER,
    actionData
  };
}

export function updateQueryParamsForGroundUp(actionData) {
  return {
    type: UPDATE_QUERY_PARAMS_FOR_GROUND_UP,
    actionData
  };
}

export const updateSearchStringForGroundUp = actionData => {
  return {
    type: UPDATE_SEARCH_STRING_FOR_GROUND_UP,
    actionData
  };
};

export const updateOnwardScrollLeftValue = actionData => {
  return {
    type: UPDATE_ONWARD_SCROLL_LEFT_VALUE,
    actionData
  };
};

export const updateReturnScrollLeftValue = actionData => {
  return {
    type: UPDATE_RETURN_SCROLL_LEFT_VALUE,
    actionData
  };
};

export const setShowModifySearchWidget = actionData => {
  return {
    type: SET_MODIFY_SEARCH_WIDGET,
    actionData
  };
};

export const setShowOnwardJourneyType = actionData => {
  return {
    type: SET_SHOW_ONWARD_JOURNEY_TYPE,
    actionData
  };
};

export const setPreSearchBannerDetails = actionData => {
  return {
    type: SET_PRE_SEARCH_BANNER_DETAILS,
    actionData
  };
};

export const setSelectedBannerDetails = actionData => {
  return {
    type: SET_SELECTED_BANNER_DETAILS,
    actionData
  };
};

export function setBannersPrefetchOnServer(actionData) {
  return {
    type: SET_BANNERS_PREFETCHED_ON_SERVER,
    actionData
  };
}

export function setBRPAppliedOfferPromoCode(actionData) {
  return {
    type: SET_BRP_APPLIED_OFFER_PROMO_CODE,
    actionData
  };
}
